import {
    DropdownProps,
    Dropdown as PrimeReactDropdown,
} from "primereact/dropdown";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const Dropdown = forwardRef<PrimeReactDropdown, DropdownProps>((props, ref) => {
    const { emptyFilterMessage, emptyMessage, filter, pt, ...rest } = props;

    const { t } = useTranslation("common");

    return (
        <PrimeReactDropdown
            ref={ref}
            filter={filter}
            showFilterClear={!!filter}
            pt={{
                filterContainer: {
                    className: "relative",
                },
                filterIcon: {
                    className: "left-3.5 text-text-500/60",
                },
                filterClearIcon: {
                    className:
                        "absolute right-0 top-0 cursor-pointer size-10 p-3.5 m-0 text-text-500/60 hover:text-text-500",
                },
                filterInput: {
                    className: "px-9 h-10",
                },
                ...pt,
            }}
            emptyFilterMessage={
                emptyFilterMessage ?? t("common:noResultsFound")
            }
            emptyMessage={emptyMessage ?? t("common:noResultsFound")}
            {...rest}
        />
    );
});

Dropdown.displayName = "Dropdown";

export default Dropdown;
